<template>
  <div>
    <div class="m-subheader ">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
         <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
		  			<li class="m-nav__item">
		  				<router-link :to="{name: 'home'}">
		  					<span class="m-nav__link-text">
                  <i class="m-nav__link-icon la la-home"></i>
                </span>
		  				</router-link>
		  			</li>
		  			<li class="m-nav__separator">
		  				>
		  			</li>
		  			<li class="m-nav__item">
		  				<a href="" class="m-nav__link">
		  					<span class="m-nav__link-text">
		  						{{'faq' | translate | titleize}}
		  					</span>
		  				</a>
		  			</li>
		  		</ul>
        </div>
      </div>
    </div>
    <div class="m-content">
      <div class="m-portlet m-portlet--tab">
        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <span class="m-portlet__head-icon m--hide">
                <i class="la la-gear"></i>
              </span>
              <h3 class="m-portlet__head-text">
                {{ 'faq' | capitalize }}
              </h3>
            </div>
          </div>
          <div class="m-portlet__head-tools">
            <ul class="m-portlet__nav">
              <li class="m-portlet__nav-item">
                <a  class="m-portlet__nav-link m-btn--pill">
                  <div class="m-input-icon m-input-icon--right">
                    <input type="text" class="form-control form-control m-input m-input--solid m-input--pill" placeholder="Search FAQ..." v-model="search_faq">
                    <span class="m-input-icon__icon m-input-icon__icon--right">
                      <span>
                        <i class="la la-search m--font-brand"></i>
                      </span>
                    </span>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="m-portlet__body">
          <div class="row">
            <div class="col-xl-3">
              <div class="m-tabs" data-tabs="true" data-tabs-contents="#m_sections">
                <ul class="m-nav m-nav--active-bg m-nav--active-bg-padding-lg m-nav--font-lg m-nav--font-bold m--margin-bottom-20 m--margin-top-10 m--margin-right-40" id="m_nav" role="tablist">
                  <li class="m-nav__item" >
                    <a class="m-nav__link m-tabs__item cursor-pointer " :class="tab_pane === 'general'?'m-tabs__item--active':'m-tabs__item'" @click.prevent="changeTab('general')">
                      <span class="m-nav__link-text">
                        {{'general' | translate | capitalize}}
                      </span>
                    </a>
                  </li>
                  <li class="m-nav__item" >
                    <a class="m-nav__link m-tabs__item cursor-pointer" :class="tab_pane === 'contactus'?'m-tabs__item--active':'m-tabs__item'" @click.prevent="changeTab('contactus')">
                      <span class="m-nav__link-text">
                        {{'contact_us' | translate | capitalize}}
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-xl-9">
              <div class="m-tabs-content" id="m_sections">
                <div v-if="questions.length <= 0" class="m-tabs-content__item m-tabs-content__item--active" id="m_section_3">
                  <div  class="text-center" >
                    <div class="m-section">
                      <h3>{{ 'conection_error' | capitalize }}</h3>
                      <br>
                      <a @click="refresh()" class="btn"><i  class="flaticon-refresh m--icon-font-size-lg6"></i></a>
                    </div>
                  </div>
                </div>
                <div v-else-if="tab_pane === 'general'" class="m-tabs-content__item m-tabs-content__item--active" id="m_section_3">
                  <h4 class="m--font-bold m--margin-top-15 m--margin-bottom-20">
                    {{'general_questions' | capitalize}}
                  </h4>
                  <div class="m-accordion m-accordion--bordered" id="m_section_3_content">
                    <div v-if="searchQuestions(question)" class="m-accordion__item" v-for="(question, index) in questions" :key="index" >
                      <div class="m-accordion__item-head collapsed" role="tab" :id="`m_section_3_content_${index}_head`" data-toggle="collapse" :href="`#m_section_3_content_${index}_body`" >
                        <span class="m-accordion__item-icon">
                          <i class="flaticon-gift"></i>
                        </span>
                        <span class="m-accordion__item-title">
                          {{question.question | capitalize}}
                        </span>
                        <span class="m-accordion__item-mode"></span>
                      </div>
                      <div class="m-accordion__item-body collapse" :id="`m_section_3_content_${index}_body`" role="tabpanel" :aria-labelledby="`m_section_3_content_${index}_head`" data-parent="#m_section_3_content">
                        <div class="m-accordion__item-content">
                          {{question.answer | capitalize}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else-if="tab_pane === 'contactus'" class="m-tabs-content__item m-tabs-content__item--active" id="m_section_3">
                  <contact  :contact_us="true" ></contact>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import contact from '@/components/contact/Contacts.vue'
  export default {
    data () {
      return {
        questions: [],
        tab_pane: 'general',
        search_faq: ''
      }
    },
    components: {
      contact
    },
    methods: {
      changeTab (name) {
        this.tab_pane = name
      },
      removeContact () {
        this.tab_pane = 'general'
      },
      refresh () {
        this.$spinner.show()
        this.$store.dispatch('getFaq', this.$i18n.locale)
          .then((response) => {
            this.$spinner.remove()
            if (response.data.status === 200) {
              this.questions = response.data.content
            }
          })
      },
      searchQuestions (object) {
        let response = true
        if (this.search_faq.length > 2) {
          let local = this.search_faq.toLowerCase()
          let question = this.$options.filters.translate(object.question)
          let answer = this.$options.filters.translate(object.answer)
          if (question.toLowerCase().indexOf(local) < 0 && answer.toLowerCase().indexOf(local) < 0) {
            response = false
          }
        }
        return response
      }
    },
    created () {
      this.$store.dispatch('getFaq', this.$i18n.locale)
        .then((response) => {
          if (response.data.status === 200) {
            this.questions = response.data.content
          }
        })
    }
  }
</script>



// WEBPACK FOOTER //
// FAQs.vue